module.exports = __webpack_public_path__ + "img/label.72d0e1c3.png";